var _defs, _polyline, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupplierOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.4 152.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "65.61 78.93 65.66 78.91 65.72 78.87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.47,0H21.12a0,0,0,0,1,0,0V12.94a0,0,0,0,1,0,0H6.47A6.47,6.47,0,0,1,0,6.47v0A6.47,6.47,0,0,1,6.47,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-161.08,437h0a5,5,0,0,1-4.95,5h-78.14a14.07,14.07,0,0,0,.9-5,14,14,0,0,0-.9-4.95H-166A5,5,0,0,1-161.08,437Z",
    transform: "translate(296.87 -301.41)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-243.27,437a14.07,14.07,0,0,1-.9,5A14,14,0,0,1-257.3,451a14,14,0,0,1-14-14,14,14,0,0,1,9.08-13.13,13.8,13.8,0,0,1,4.95-.9,13.94,13.94,0,0,1,5.78,1.24,14,14,0,0,1,7.35,7.84A14,14,0,0,1-243.27,437Z",
    transform: "translate(296.87 -301.41)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-251.94,436.6a5.43,5.43,0,0,1-.34,1.9,5.35,5.35,0,0,1-5,3.47,5.36,5.36,0,0,1-5.36-5.37,5.37,5.37,0,0,1,3.47-5,5.37,5.37,0,0,1,1.89-.34,5.25,5.25,0,0,1,2.21.48,5.36,5.36,0,0,1,2.81,3A5.41,5.41,0,0,1-251.94,436.6Z",
    transform: "translate(296.87 -301.41)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-251.52,320.8V424.23A13.94,13.94,0,0,0-257.3,423a13.8,13.8,0,0,0-4.95.9V323.39a10.56,10.56,0,0,0-10.55-10.56h-5.13V302.11h7.71A18.7,18.7,0,0,1-251.52,320.8Z",
    transform: "translate(296.87 -301.41)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-157.47,386.07v33.09a1.33,1.33,0,0,1-1.33,1.32h-33.09a1.32,1.32,0,0,1-1.32-1.32V386.07a1.33,1.33,0,0,1,1.32-1.33H-181v17.69a1.51,1.51,0,0,0,1.5,1.51h7.82a1.52,1.52,0,0,0,1.51-1.51V384.74h11.37A1.34,1.34,0,0,1-157.47,386.07Z",
    transform: "translate(296.87 -301.41)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-206.77,334.25v30a1.2,1.2,0,0,1-1.2,1.2h-30a1.2,1.2,0,0,1-1.2-1.2v-30A1.22,1.22,0,0,1-238,333h9.88V349.1a1.37,1.37,0,0,0,1.36,1.37h7.1a1.37,1.37,0,0,0,1.37-1.37V333H-208A1.21,1.21,0,0,1-206.77,334.25Z",
    transform: "translate(296.87 -301.41)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-198.36,372.61v46.57a1.71,1.71,0,0,1-1.51,1.86H-237.7a1.71,1.71,0,0,1-1.51-1.86V372.61a1.73,1.73,0,0,1,1.51-1.87h12.44v19.9a2,2,0,0,0,1.72,2.12h8.94a2,2,0,0,0,1.72-2.12v-19.9h13A1.72,1.72,0,0,1-198.36,372.61Z",
    transform: "translate(296.87 -301.41)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierOrders);
export default __webpack_public_path__ + "static/media/SupplierOrders.b3d0cd82fd8eb5a9637c9b10c6ba12ed.svg";
export { ForwardRef as ReactComponent };